import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import logo from "../../../../assets/HarmaLogo2.png";
import logo2 from "../../../../assets/7.png";
import harmawhite from "../../../../assets/9.png";
import harmablack from "../../../../assets/4.png";
import { setPlan } from "../../../../slices/planSlice";
import { message } from "antd";
import PlanPayment from "../../../../components/payment/planPayment";
import Confetti from 'react-confetti';

const stripePromise = loadStripe("tu_clave_publica_de_stripe");

const CheckoutForm = ({ plan, setIsModalOpen }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cardType, setCardType] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate()
  
  

  const errorMessage = () => {
    messageApi.open({
      type: "error",
      content: "Error al procesar tu pago",
    });
  };

  
  const dispatch = useDispatch();

  
  useEffect(() => {
    if (!elements) return;

    const cardNumberElement = elements.getElement(CardNumberElement);
    if (cardNumberElement) {
      cardNumberElement.on("change", (event) => {
        if (event.brand && event.brand !== "unknown") {
          setCardType(event.brand);
        } else {
          setCardType(null);
        }
      });
    }
  }, [elements]);

  const handleSubmit = async (event) => {
    event.preventDefault();

  try {
    
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      handleSuccessPayment(plan);
    }, 1000); 
  } catch (error) {
    console.error(error);
    errorMessage()
    
  }
  };

  const getCardIcon = (brand) => {
    switch (brand) {
      case "visa":
        return "https://img.icons8.com/color/48/000000/visa.png";
      case "mastercard":
        return "https://img.icons8.com/color/48/000000/mastercard.png";
      case "amex":
        return "https://img.icons8.com/color/48/000000/amex.png";
      case "discover":
        return "https://img.icons8.com/color/48/000000/discover.png";
      default:
        return null;
    }
  };

  const handleSuccessPayment = (plan) => {
    setIsModalOpen(true)
    dispatch(setPlan(plan)); 
  };

  

  return (
    <form onSubmit={handleSubmit}>
    {contextHolder}
      <div className="mb-6">
        <label className="block text-sm font-medium text-subtitle mb-1">Número de tarjeta</label>
        <div className="relative">
          <CardNumberElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {cardType && (
            <img
              src={getCardIcon(cardType)}
              alt={cardType}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 h-6"
            />
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-between mb-6">
        <div className="w-full lg:w-1/2 lg:mr-4 mb-6 lg:mb-0">
          <label className="block text-sm font-medium text-subtitle mb-1">Fecha de expiración</label>
          <CardExpiryElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="w-full lg:w-1/2 lg:ml-4">
          <label className="block text-sm font-medium text-subtitle mb-1">CVV</label>
          <CardCvcElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#424770",
                  "::placeholder": {
                    color: "#aab7c4",
                  },
                },
                invalid: {
                  color: "#9e2146",
                },
              },
            }}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      {error && <div className="text-red-500 text-sm mb-4">{error}</div>}
      <button
        type="submit"
        disabled={loading}
        className="w-full bg-black shadow hover:bg-opacity-90 cursor-pointer dark:bg-white dark:text-black text-white py-3 rounded-lg transition duration-300"
      >
        {loading ? "Procesando..." : "Pagar"}
      </button>
    </form>
  );
};

export default function Pago() {
  const { plan } = useSelector((state) => state.clientes);
  const navigate = useNavigate();
  const { isDarkMode } = useSelector((state) => state.darkMode);

  const beneficios = plan?.beneficios || [];
  const [isModalOpen, setIsModalOpen] = useState(false)

  

  return (
    <div className="w-full sm:h-screen bg-gray-50 dark:bg-background flex sm:mt-16 justify-center font-poppina p-2">
    <PlanPayment  isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}  />
    
      <div className="w-[80%] sm:h-[600px] bg-card dark:border shadow-lg rounded-lg flex flex-col lg:flex-row">
        <div className="w-full lg:w-[1000px] px-8 py-2 border-b lg:border-r border-gray-200">
          <div className="flex items-center justify-between w-full border-b">
            <div className="mb-5">
              <h1 className="text-2xl font-bold text-text mb-3">Compra</h1>
              <p onClick={() => navigate(-1)} className="text-subtitle underline text-xs cursor-pointer">cambiar de plan</p>
            </div>
            <img className="sm:w-36 w-20" src={isDarkMode ? logo2 : logo} alt="" />
          </div>

          <div className="w-full py-2 my-5 border-b mt-3">
            <div className="sm:flex justify-between">
              <div className="flex sm:mb-0 mb-2">
                <img className={`sm:w-10 w-10 p-1 rounded-md mr-1 ${plan?.nombre === "Plan Básico" ? "bg-blue-500" : plan?.nombre === "Plan Pro" ? "bg-purple-500" : plan?.nombre === "Plan Premium" ? "bg-yellow-700 h-10" : ""}`} src={isDarkMode ? harmablack : harmawhite} alt="" />
                <p className="text-text text-2xl font-semibold">{plan?.title || "Plan Básico"}</p>
              </div>
              <p className="text-text font-bold">{plan?.price || "29.99"} MXN / mes</p>
            </div>
            <div className="flex flex-row font-poppina text-base mt-5 ml-5">
              <ul className="list-disc">
                {beneficios.map((beneficio, i) => (
                  <li key={i} className="text-start text-sm text-text">
                    {beneficio}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Elements stripe={stripePromise}>
            <CheckoutForm plan={plan} setIsModalOpen={setIsModalOpen} />
          </Elements>
        </div>

        <div className="w-full lg:w-[400px] p-8">
          <h2 className="text-xl font-semibold text-text mb-6">Resumen de la compra</h2>
          
          <div className="mb-6 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <div>
              <p className="text-sm text-subtitle">Compañía</p>
              <p className="text-lg font-medium text-text">Harma Studio</p>
            </div>
          </div>

          <div className="mb-6 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
            </svg>
            <div>
              <p className="text-sm text-subtitle">Número de orden</p>
              <p className="text-lg font-medium text-text">1266201</p>
            </div>
          </div>

          <div className="mb-6 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <div>
              <p className="text-sm text-subtitle">Plan</p>
              <p className="text-lg font-medium text-text">{plan?.nombre || "Plan Básico"}</p>
            </div>
          </div>

          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <p className="text-sm text-subtitle">Total a pagar</p>
                <p className="text-2xl font-semibold text-text">${plan?.price || "29.99"} MXN</p>
              </div>
            </div>
            <div className="text-gray-500">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
          </div>
          <div>
            <ul className="text-xs text-subtitle mt-2 list-disc ml-4">
              <li>Facturación mensual a partir de hoy.</li>
              <li>Cancela cuando quieras online. Consulta las condiciones</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}